import React, { useEffect, useState } from 'react'
import { Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { useTranslation } from 'react-i18next'
import {
  modalAddFieldsData,
  modalAddFieldsVisible
} from '../../redux/reducers/modal-add-fields/modal-add-fields.selectors'
import {
  setModalAddFieldsVisible,
  showModalAddFields
} from '../../redux/reducers/modal-add-fields/modal-add-fields.actions'
import { ItemField } from './components/ItemField'
import { FieldSetupEnum } from '../../models/enums/field-setup.enum'
import { Setup } from '../../models/interfaces/setup.interface'
import { saveSetup } from '../../redux/reducers/training-workout/training-workout.actions'
import { getFullSetupDefault, getNameByField } from '../TrainingWorkout/components/Utils'

export const AddFieldsModal = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isVisible = useAppSelector(modalAddFieldsVisible)
  const data = useAppSelector(modalAddFieldsData)
  const [setupFieldsActived, setSetupFieldsActived] = useState<FieldSetupEnum[]>()

  const onClose = () => dispatch(setModalAddFieldsVisible(false))

  useEffect(() => {
    if (data) {
      setSetupFieldsActived(data?.setup.map(item => item.field))
    }
  }, [data])

  const handleIncludeField = (item: Setup, active: boolean | undefined) => {
    if (!active && data) {
      const newData = { ...data, setup: [...data.setup, item] }
      dispatch(showModalAddFields({ data: newData, isVisible: true }))
      dispatch(saveSetup({ setups: newData.setup, id: data.id }))
    }
  }

  return (
    <Dialog
      fullWidth={true}
      open={isVisible}
      onClose={onClose}
    >
      <DialogTitle>{t('trainingWorkout.addField')}</DialogTitle>
      <DialogContent>
        <Stack direction="row" width="100%" flexWrap="wrap">
          {getFullSetupDefault(data?.workoutType)?.map((item: Setup, key: number) => {
            const actived = setupFieldsActived?.includes(item.field)
            return (
              <ItemField
                key={key}
                name={getNameByField(item.field)}
                actived={actived}
                onClick={() => handleIncludeField(item, actived)}
              />
            )
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={onClose}>
          {t('general.btn.dismiss')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
